import { combineReducers, createReducer, PayloadAction } from "@reduxjs/toolkit";

import {
  projectsExportDialog,
  projectsExportError,
  projectsExportNext,
  projectsExportStart,
  projectsExportSuccess
} from "../Actions";

const showDialog = createReducer(false, {
  [projectsExportDialog.type]: (_, { payload }: PayloadAction<boolean>) => payload,
  [projectsExportError.type]: () => false,
  [projectsExportSuccess.type]: () => false
});

const exportIndex = createReducer(-1, {
  [projectsExportDialog.type]: (_, { payload }: PayloadAction<boolean>) => (payload ? 0 : -1),
  [projectsExportError.type]: () => -1,
  [projectsExportNext.type]: (state) => state + 1,
  [projectsExportStart.type]: () => 0,
  [projectsExportSuccess.type]: () => -1
});

export const Export = combineReducers({
  showDialog,
  exportIndex
});
